/* eslint-disable global-require */
module.exports = ['subscriptions.list.constants.m1', 'subscriptions.list.constants.m2', 'subscriptions.list.constants.m3', 'subscriptions.list.constants.m4', ...require('./Users/i18n')];
